module.exports = __webpack_public_path__ + "static/media/38.02ed8f6a.jpg";